import React from 'react';
import {
  Tabs as HeroTabs,
  Tab,
  TabsProps as HeroTabsProps,
} from '@heroui/react';

export interface TabItem {
  key: string;
  title: string | React.ReactNode;
  icon?: React.ReactNode;
  content?: React.ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  size?: HeroTabsProps['size'];
  color?: HeroTabsProps['color'];
  variant?: HeroTabsProps['variant'];
  radius?: 'full' | 'lg' | 'md' | 'sm' | 'none';
  defaultSelectedKey?: string;
  value?: string;
  onChange?: (key: string) => void;
  className?: string;
  isToggle?: boolean;
  classNames?: {
    base?: string;
    tabList?: string;
    cursor?: string;
    tab?: string;
  };
}

const Tabs: React.FC<TabsProps> = ({
  items,
  size = 'sm',
  color = 'primary',
  variant = 'solid',
  radius = 'md',
  defaultSelectedKey,
  value,
  onChange,
  className = '',
  isToggle = false,
  classNames,
}) => {
  return (
    <>
      <style>{`
        .custom-tabs button[role="tab"]:not([data-selected="true"]) [data-slot="tabContent"] {
          color: #6e6e6e !important;
        }
        .custom-tabs button[role="tab"]:not([data-selected="true"]):hover {
          opacity: 1 !important;
          background-color: #f5f5f5 !important;
        }
        .custom-tabs button[role="tab"]:not([data-selected="true"]):hover [data-slot="tabContent"] {
          color: #4a4a4a !important;
          
        }
      `}</style>

      <HeroTabs
        size={size}
        color={color}
        variant={variant}
        radius={radius}
        defaultSelectedKey={defaultSelectedKey}
        selectedKey={value}
        onSelectionChange={(key) => onChange?.(String(key))}
        className={`custom-tabs ${className}`}
        classNames={
          classNames ?? {
            tabList: isToggle ? 'w-full' : '',
          }
        }
      >
        {items.map(({ key, title, icon }) => (
          <Tab
            key={key}
            title={
              <div className="flex items-center gap-2">
                {icon && <span>{icon}</span>}
                <span>{title}</span>
              </div>
            }
          />
        ))}
      </HeroTabs>
    </>
  );
};

export default Tabs;
